import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-object-type',
  templateUrl: './delete-object-type.component.html',
  styleUrls: ['./delete-object-type.component.css']
})
export class DeleteObjectTypeComponent implements OnInit {

  objectData: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  typeId: any

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllTypeList()

  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllTypeList();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllTypeList();
  }



  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllTypeList(){
    this.generic_service.getAllTypeList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }



  deleteIdSelect(id:any){
    this.typeId = id
  }

  deleteType(){
    this.generic_service.deleteObjectTypeMaster(this.typeId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllTypeList()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}